export const SET_LOADING = "setLoading";
export const SET_ERROR = "setError";
export const SET_EXPORT = "setExport";
export const SET_ABOUT_COMPANY = "setAboutCompany";
export const SET_ABOUT_COMPANY_BANNER = "setAboutCompanyBanner";
export const SET_CERTIFICATES = "setCertificates";
export const SET_MANAGEMENT = "setManagement";
export const SET_CONTACT_US = "setContactUs";